import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import UserStatistic from '@/modules/statistic/views/UserStatistic.vue'
import BrokerCommissionsStatistic from '@/modules/statistic/views/BrokerCommissionsStatistic.vue'
import TransactionStatistic from '@/modules/statistic/views/TransactionStatistic.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const statisticRouter = [
  {
    path: `${baseRoute}/reports/usage`,
    name: 'reports-usage',
    meta: {
      component: UserStatistic
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/reports/transactions`,
    name: 'reports-transactions',
    meta: {
      component: TransactionStatistic
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/reports/broker-commissions`,
    name: 'reports-broker-commissions',
    meta: {
      component: BrokerCommissionsStatistic
    },
    component: PrivateRouter,
  },
]
export default statisticRouter
